module.exports = __webpack_public_path__ + "img/story034@2x.23038d94.webp";